"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALGORITHMS = exports.SymmetricCryptoAlgorithm = exports.BinaryDataEncoding = void 0;
var BinaryDataEncoding;
(function (BinaryDataEncoding) {
    BinaryDataEncoding["HEX"] = "hex";
})(BinaryDataEncoding = exports.BinaryDataEncoding || (exports.BinaryDataEncoding = {}));
var SymmetricCryptoAlgorithm;
(function (SymmetricCryptoAlgorithm) {
    SymmetricCryptoAlgorithm["AES256CTR"] = "AES256CTR";
})(SymmetricCryptoAlgorithm = exports.SymmetricCryptoAlgorithm || (exports.SymmetricCryptoAlgorithm = {}));
exports.ALGORITHMS = (_a = {},
    _a[SymmetricCryptoAlgorithm.AES256CTR] = {
        type: SymmetricCryptoAlgorithm.AES256CTR,
        ivSize: 32
    },
    _a);
